/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Flag: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="flag" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M700.4 1020L723.0666666666666 906.6666666666669H1020V566.6666666666667H829.6L806.9333333333333 680H396.6666666666667V1020H700.4zM793.3333333333333 1133.3333333333333H283.3333333333333V170H396.6666666666667V566.6666666666667H714L736.6666666666666 453.3333333333334H1133.3333333333333V1020H816L793.3333333333333 1133.3333333333333z" : "M560.32 816L578.4533333333334 725.3333333333333H816V453.3333333333333H663.6800000000001L645.5466666666667 544H317.3333333333334V816H560.32zM634.6666666666667 906.6666666666666H226.6666666666667V136H317.3333333333334V453.3333333333333H571.2L589.3333333333334 362.6666666666667H906.6666666666669V816H652.8000000000001L634.6666666666667 906.6666666666666z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Flag.displayName = `Blueprint5.Icon.Flag`;
export default Flag;
